module.exports = __webpack_public_path__ + "static/media/DevOps-Resume Nitesh karki.3320f7cc.pdf";